import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesBroadcastMain } from './modules/ui/Main';

const BroadcastPage = (
  <SuspensePage>
    <PagesBroadcastMain />
  </SuspensePage>
);

export default BroadcastPage;
